// extracted by mini-css-extract-plugin
export default {"heading":"TableContainer_heading__tKyGb","TableContainer":"TableContainer_TableContainer__GJiHP","overlay":"TableContainer_overlay__kgXVZ"};